export { default } from './BadgeRating';
